import { render, staticRenderFns } from "./projectConstruction.vue?vue&type=template&id=94ab82ca"
import script from "./projectConstruction.vue?vue&type=script&lang=js"
export * from "./projectConstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports